import { render, staticRenderFns } from "./EducationCenter.vue?vue&type=template&id=929683f4&"
import script from "./EducationCenter.vue?vue&type=script&lang=js&"
export * from "./EducationCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports